import { openModal } from '~/components/controllers/modal/controls';
import modalManageDignities from '~/components/app/dignities/modal-manage-dignities.vue';
import modalUpdatePassword from '~/components/app/user/modal-update-password.vue';

export function useManageUser() {
  const userStore = useUserStore();
  const authStore = useAuthStore();

  const updateDignities = async () => {
    await openModal(modalManageDignities).then(async ([success]: [success: boolean]) => {
      if (success) {
        await userStore.getUser();
      }
    });
  };

  const updatePassword = async () => {
    await openModal(modalUpdatePassword).then(async ([success]: [success: boolean]) => {
      if (success) {
        await authStore.logout();
      }
    });
  };

  return { updateDignities, updatePassword };
}
